import React from "react";
import PropTypes from "prop-types";
import BcInvoiceSummaryRequestDetailsRow from "./BcInvoiceSummaryRequestDetailsRow";
import BcInvoiceSummarySection from "./BcInvoiceSummarySection";

const BcInvoiceExportSummaryModal = ({
  invoices,
  totalInvoices,
  errMessage,
  onClose
}) => {
  const totalSuccessfullyCreatedInvoices = invoices?.length
    ? invoices?.filter((invoice) => invoice?.id)?.length || 0
    : 0;

  const totalFailedToCreateInvoices = invoices?.length
    ? invoices?.filter((invoice) => !invoice?.id)?.length || 0
    : 0;

  const totalPreventedInvoices =
    totalInvoices -
      (totalFailedToCreateInvoices + totalSuccessfullyCreatedInvoices) || 0;

  return (
    <React.Fragment>
      <BcInvoiceSummaryRequestDetailsRow
        title="Total Invoice(s) Created:"
        unattemptedTotal={totalPreventedInvoices}
        successTotal={totalSuccessfullyCreatedInvoices}
        failedTotal={totalFailedToCreateInvoices}
      />
      {invoices?.map((invoice) => (
        <BcInvoiceSummarySection
          key={invoice?.customerNumber}
          invoice={invoice}
          invoiceLines={invoice.invoiceLines}
        />
      ))}
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <button className="btn btn-cancel" onClick={onClose}>
          Close
        </button>
      </div>
    </React.Fragment>
  );
};

BcInvoiceExportSummaryModal.propTypes = {
  invoices: PropTypes.array,
  totalInvoices: PropTypes.number,
  errMessage: PropTypes.string,
  onClose: PropTypes.func
};

export default BcInvoiceExportSummaryModal;
